/**
 * TraderName Context
 *
 * Provides the current trader name to all child components.
 * Used for strategy execution to know which trader to execute for.
 *
 * Default trader name is 'njovy' when on main dashboard (/).
 * When on /user/:trader_name/opportunities, uses the trader from URL.
 */

import React, { createContext, useContext, ReactNode } from 'react';

interface TraderNameContextType {
  traderName: string;
}

const TraderNameContext = createContext<TraderNameContextType | undefined>(undefined);

interface TraderNameProviderProps {
  traderName: string;
  children: ReactNode;
}

export const TraderNameProvider: React.FC<TraderNameProviderProps> = ({ traderName, children }) => {
  return (
    <TraderNameContext.Provider value={{ traderName }}>
      {children}
    </TraderNameContext.Provider>
  );
};

export const useTraderName = (): string => {
  const context = useContext(TraderNameContext);
  if (context === undefined) {
    // Default to 'njovy' if not in a provider
    return 'njovy';
  }
  return context.traderName;
};
